import React from 'react'

export default function Card({ img, desc, title, learn }) {
  return (
    <div className='flex flex-col m-5 ' >
      <img src={img} alt="img" className='w-16  mb-2' />
      <h1 className='text-blue-900 text-2xl ' >{title}</h1>
      <p className='font-sans my-2' >{desc}</p>
      {learn && <a href={learn} className='text-green-800 font-semibold tracking-wide font-sans  hover:text-blue-900' >Learn More</a>}
    </div>
  )
}
